import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { venueService } from "services/venueService";
import { ListingGalleryImage } from "./ListingImageGallery/utils/types";
import { Squares2X2Icon } from "@heroicons/react/24/outline";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

export default function HomeImageGallery({ venue }: any) {
  const [cover, setCover] = useState<string | null>(null);
  const [images, setImages] = useState<ListingGalleryImage[]>([]);

  const thisPathname = useLocation().pathname;

  const router = useNavigate();

  const handleOpenModalImageGallery = () => {
    router(`${thisPathname}?modal=PHOTO_TOUR_SCROLLABLE`);
  };

  useEffect(() => {
    (async function () {
      const res = await venueService.getVenuePhotoAlbumByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID));

      if (!res) return;

      setCover(res?.cover);

      setImages(
        res?.album?.map((item: any, index: number) => {
          return {
            id: index,
            url: item?.url,
          };
        })
      );
    })();
  }, []);

  return (
    <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
      <div className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer " onClick={handleOpenModalImageGallery}>
        <img className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full" src={cover ?? ""} alt="" sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw" />
        <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
      </div>
      {images
        ?.filter((_, i) => i >= 0 && i < 6)
        .map((item, index) => (
          <div key={index} className={`relative rounded-md sm:rounded-xl overflow-hidden ${index >= 3 ? "hidden sm:block" : ""}`}>
            <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
              <img className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full" src={item.url} alt="" sizes="400px" />
            </div>

            {/* OVERLAY */}
            <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer" onClick={handleOpenModalImageGallery} />
          </div>
        ))}

      <button
        className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
        onClick={handleOpenModalImageGallery}>
        <Squares2X2Icon className="w-5 h-5" />
        <span className="ml-2 text-neutral-800 text-sm font-medium">顯示圖集</span>
      </button>
    </div>
  );
}
